import React from 'react';
import ContactFrom from '../Components/Contact';

const contactForm = () => {
	return <ContactFrom />;
};

export default contactForm;
